/**
 * Estensione del prototype String che permette di calcolare la larghezza di una stringa.
 * Questa � calcolata in base alla dimensione ed al tipo di font usato.
 *
 * @param {CSSFontFaceRule} font
 * @return {Number}
 */
String.prototype.width = function (font) {
  var f = font || '12px arial',
    o = $('<span></span>')
      .text(this.replace(" ", '\u2002'))
      .css({'position': 'absolute', 'float': 'left', 'white-space': 'nowrap', 'visibility': 'hidden', 'font': f})
      .appendTo($('body')),
    w = o.width();

  o.remove();

  return w;
};